export const SystemApp={
  base_url: 'https://romelux-light.com/',
  base_url_api: 'https://romelux-light.com:8000'
}
